module.exports = {"210311005":"对桩石街道","210311006":"汤岗子街道","210311007":"东鞍山街道","210311102":"唐家房镇","210311103":"大屯镇","210311104":"甘泉镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/210311.json
// module id = 528
// module chunks = 0